// Remove leading zeros from number and convert to string
const convertNumberToString = num => num ? Number(num).toString() : '';

export default convertNumberToString;
